import { createSelector } from 'reselect'

import { SELECTED_PARTNERSHIP_ID } from '../actions/partnerships'

// PLOP_APPEND_PATTERN_ANCHOR

// get partnerships
export const partnershipsSelector = createSelector(
  ({ partnerships }) => partnerships.partnerships.results,
  results => results
)

export const partnershipsWasLoadedSelector = createSelector(
  ({ partnerships }) => partnerships.partnerships.wasLoaded,
  wasLoaded => wasLoaded
)

export const partnershipsIsLoadingSelector = createSelector(
  ({ partnerships }) => partnerships.partnerships.isLoading,
  isLoading => isLoading
)

export const partnershipsErrorSelector = createSelector(
  ({ partnerships }) => partnerships.partnerships.error,
  error => error
)

export const partnershipsNextSelector = createSelector(
  ({ partnerships }) => partnerships.partnerships.paging.next,
  next => next
)

// selected partnership
export const selectedPartnershipSelector = createSelector(
  ({ partnerships }) => partnerships.selectedPartnership,
  selectedPartnership => selectedPartnership
)

export const selectedPartnershipIdSelector = createSelector(
  ({ partnerships }) => partnerships[SELECTED_PARTNERSHIP_ID],
  selectedPartnershipId => selectedPartnershipId
)

export const selectedPartnershipCurrency = createSelector(
  ({ partnerships }) => partnerships.selectedPartnership.external_accounts,
  adAccounts => {
    // Select the currency from the first ad account in the list
    // if there is none, don’t display a currency symbol at all
    const hasAdAccount = adAccounts && adAccounts[0]
    return hasAdAccount ? { currency: adAccounts[0].currency, currency_symbol: adAccounts[0].currency_symbol } : {}
  }
)

export const selectedPartnershipRightsHolderIdSelector = createSelector(
  ({ partnerships }) => partnerships.selectedPartnership.rights_holder,
  rightsHolderId => rightsHolderId
)

export const selectedPartnershipIsDigitalSelector = createSelector(
  ({ partnerships }) => partnerships.selectedPartnership.providers,
  // if partnership has providers (platforms) available, then it's treated as digital
  providers => providers && !!providers.length
)

// create partnership
export const createPartnershipWasCreatedSelector = createSelector(
  ({ partnerships }) => partnerships.createPartnership.wasCreated,
  wasCreated => wasCreated
)

export const createPartnershipIsLoadingSelector = createSelector(
  ({ partnerships }) => partnerships.createPartnership.isLoading,
  isLoading => isLoading
)

export const createPartnershipErrorSelector = createSelector(
  ({ partnerships }) => partnerships.createPartnership.error,
  error => error
)

// update partnership
export const updatePartnershipSelector = createSelector(
  ({ partnerships }) => partnerships.updatePartnership,
  updatePartnership => updatePartnership
)

export const updatePartnershipWasUpdatedSelector = createSelector(
  ({ partnerships }) => partnerships.updatePartnership.wasUpdated,
  wasUpdated => wasUpdated
)

export const updatePartnershipIsLoadingSelector = createSelector(
  ({ partnerships }) => partnerships.updatePartnership.isLoading,
  isLoading => isLoading
)

export const updatePartnershipErrorSelector = createSelector(
  ({ partnerships }) => partnerships.updatePartnership.error,
  error => error
)

// delete partnership
export const deletePartnershipSelector = createSelector(
  ({ partnerships }) => partnerships.deletePartnership,
  deletePartnership => deletePartnership
)

export const deletePartnershipIsLoadingSelector = createSelector(
  ({ partnerships }) => partnerships.deletePartnership.isLoading,
  isLoading => isLoading
)

export const deletePartnershipErrorSelector = createSelector(
  ({ partnerships }) => partnerships.deletePartnership.error,
  error => error
)

// sendOutstandingActionsNotification
export const outstandingActionsNotificationWasLoadedSelector = createSelector(
  ({ partnerships }) => partnerships.outstandingActionsNotification.wasLoaded,
  wasLoaded => wasLoaded
)

export const outstandingActionsNotificationIsLoadingSelector = createSelector(
  ({ partnerships }) => partnerships.outstandingActionsNotification.isLoading,
  isLoading => isLoading
)

export const outstandingActionsNotificationErrorSelector = createSelector(
  ({ partnerships }) => partnerships.outstandingActionsNotification.error,
  error => error
)
